export { default } from "./Input";



// WEBPACK FOOTER //
// ./src/components/Input/index.js